interface IWorkerOne {
  hello?: (name: string) => Promise<string>;
  postMessage?: (data: any) => void;
  onmessage?: (data: any) => void | null;
}

let workerInstance = null;

export const startPxWorker = () => {
  if (!workerInstance) {
    console.log("px.worker INSTANCE STARTING startWorker");
    workerInstance = new Worker(new URL("./px.worker.ts", import.meta.url));
  }
  return workerInstance;
};

export const terminatePxWorker = () => {
  if (workerInstance) {
    workerInstance.terminate();
    workerInstance = null;
  }
};

export const getPxWorker = () => {
  return workerInstance;
};
